// extracted by mini-css-extract-plugin
export default {"companyContainer":"HJ-z","companyImage":"IJ-z","container":"JJ-z","heading":"KJ-z","darkText":"LJ-z","smallHeading":"MJ-z","darkBackground":"NJ-z","whiteBackground":"OJ-z"};